/**
* 公司
*/
const company = {
  
createCompany: "/api/createCompany",//创建
modifyCompany: "/api/modifyCompany",//修改
getCompanyInfo: "/api/getCompanyInfo",//查询公司信息
getSubcompaniesInfo: "/api/getSubcompaniesInfo",//查询子公司信息
getCompanyLogo: "/api/getCompanyLogo",//查询公司logo
setCompanyLogo: "/api/setCompanyLogo",//设置公司logo
quickInitializeCompany: "/api/quickInitializeCompany",//快速初始化公司
}

export default company